
export class StructuredDataType {

    static PROPOSAL = "proposal";
    static OPINION = "opinion";
    static ARGUMENT = "argument";
    static MEMBER = "member";
    static ORGANIZATION = "organization";
}